import { render, staticRenderFns } from "./LawNormViewStageModal.vue?vue&type=template&id=605a7ee6"
import script from "./LawNormViewStageModal.vue?vue&type=script&lang=js"
export * from "./LawNormViewStageModal.vue?vue&type=script&lang=js"
import style0 from "./LawNormViewStageModal.vue?vue&type=style&index=0&id=605a7ee6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports